export default {"src":"/_next/static/media/loom.e5111cf3.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};